import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fechaEs',
  standalone: true
})
export class FechaEsPipe implements PipeTransform {

  transform(value: any, returnType: 'date' | 'daysLeft' | 'DMY' = 'date'): string {
    try {
        const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
        const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

        const currentDate = new Date();
        const targetDate = new Date(value);

        const daysLeft = this.differenceInDays(currentDate, targetDate);

        if (returnType === 'DMY') {
          return this.formatDMY(new Date(value));
        }

        if (returnType === 'daysLeft') {
          if (daysLeft < 0) {
              return "Vencida";
          }
          if (daysLeft === 0) {
              return "Vence hoy";
          }
          return `${daysLeft} días`;
        }

        if (isNaN(targetDate.getTime())) {
            return "Fecha no válida";
        }

        const dayName = days[targetDate.getUTCDay()];
        const day = targetDate.getUTCDate();
        const monthName = months[targetDate.getUTCMonth()];
        const year = targetDate.getUTCFullYear();

        return `${dayName}, ${day} ${monthName} de ${year}`;
    } catch (err) {
        console.error("Error al transformar la fecha:", err);
        return value;
    }
  }


  private differenceInDays(date1: Date, date2: Date): number {
      const oneDay = 24 * 60 * 60 * 1000;
      const diffDays = Math.ceil((date2.getTime() - date1.getTime()) / oneDay);
      return diffDays;
  }

  private formatDMY(d: any): string {
    d = d || new Date();
    return ('0' + d.getUTCDate()).slice(-2) + '/' +
           ('0' + (d.getUTCMonth() + 1)).slice(-2) + '/' +
           ('000' + d.getUTCFullYear()).slice(-4);
  }



}
